import { render, staticRenderFns } from "./PluConfigModal.vue?vue&type=template&id=66503b2b&scoped=true&"
import script from "./PluConfigModal.vue?vue&type=script&lang=js&"
export * from "./PluConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./PluConfigModal.vue?vue&type=style&index=0&id=66503b2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66503b2b",
  null
  
)

export default component.exports